import { useEffect, useState } from 'react'
import { PageTitle, usePageData } from '../../../_metronic/layout/core'
import Table from '../../components/QuotesGridPage/Table/Table'
import { dollarUSLocale } from '../../helpers/dollarUSLocale'
import CircleIcon from '@mui/icons-material/Circle';
import Toolbar from '../../components/InvoicesGridPage/Toolbar'
import InvoiceBreakdownModal from '../../components/ShippingItemsPage/InvoiceBreakdownModal'
import HistorySelect from '../../components/QuotesGridPage/History/HistorySelect';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { UserModel } from '../../modules/auth/models/UserModel';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import axios from 'axios';
import { CircularProgress,} from '@mui/material';

export const InvoicesGrid = () => {
  let {setHistoryElement} = usePageData()
  const [loading, setLoading] = useState(false)
  const [totalResults, setTotalResults] = useState(0)
  const [pageNumber, setPageNumber] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(25)
  const [invoices, setInvoices] = useState([])
  const [filters, setFilters] = useState({
    invoiceNumber: '',
    BOLNumber: '',
    status: 'Unpaid',
  })
  const [openInvoiceBreakdownModal, setOpenInvoiceBreakdownModal] = useState(false)
  const [rowSelected, setRowSelected] = useState({})
  const [ascOrDesc, setAscOrDesc] = useState('')
  const [field, setField] = useState('')
  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  const defaults = useSelector<RootState>(({pages}) => pages.defaults) as any

  const totalRender = (rowData) => {
    return (
      <button
        style={{ 
          backgroundColor: 'transparent',
          border: 'none',
          padding: 0,
          textDecoration: 'underline'
        }}
        onClick={() => {
          setRowSelected(rowData)
          setOpenInvoiceBreakdownModal(true)
        }}
      >
        {dollarUSLocale.format(rowData.total)}
      </button>
    )
  }
  
  const referenceRender = (rowData) => {
    return (
      <div>
        {rowData.shipperReferenceNumber && `${rowData.shipperReferenceNumber} - `}{rowData.shipperReferenceNumber && `${rowData.consigneeReferenceNumber} - `}{rowData.billPartyReferenceNumber}
      </div>
    )
  }

  const setValues = (ascOrDesc, field) => {
    setAscOrDesc(ascOrDesc)
    setField(field)
  }

  const findColumnDefault = (columnName) => {
      return defaults.invoices.find(col => col.name === columnName)?.hidden
  }

  const [columns, setColumns] = useState([
    { title: 'Invoice#', field: 'invoiceNumber', hidden: findColumnDefault('invoiceNumber') || false, customSort: (a, b, c, d) => {setValues(d, 'invoiceNumber')}},
    { title: 'Invoice Date', field: 'issueDate', type: 'date', hidden: findColumnDefault('issueDate') || false, dateSetting: { locale: "en-US" }, customSort: (a, b, c, d) => {setValues(d, 'issueDate')}},
    { title: 'Due', field: 'dueDate', type: 'date', dateSetting: { locale: "en-US" }, hidden: findColumnDefault('dueDate') || false, customSort: (a, b, c, d) => {setValues(d, 'dueDate')}},
    { title: 'BOL#', field: 'BOLNumber', hidden: findColumnDefault('BOLNumber') || false, customSort: (a, b, c, d) => {setValues(d, 'BOLNumber')}},
    { title: 'PRO#', field: 'carrierPRO', hidden: findColumnDefault('carrierPRO') || false, customSort: (a, b, c, d) => {setValues(d, 'carrierPRO')}},
    { title: 'Mode', field: 'mode', hidden: findColumnDefault('mode') || false, customSort: (a, b, c, d) => {setValues(d, 'mode')}},
    { title: 'Carrier', field: 'carrierName', hidden: findColumnDefault('carrierName') || false, customSort: (a, b, c, d) => {setValues(d, 'carrierName')}},
    { title: 'Reference#', field: 'shipperReferenceNumber', render: referenceRender, hidden: findColumnDefault('shipperReferenceNumber') || false, customSort: (a, b, c, d) => {setValues(d, 'shipperReferenceNumber')}},
    { title: 'Total', field: 'total', type: 'currency', render: totalRender, hidden: findColumnDefault('total') || false, customSort: (a, b, c, d) => {setValues(d, 'total')}},
  ])

  useEffect(() => {
    setHistoryElement(
      <HistorySelect
        setFilters={setFilters}
        historyFor='InvoicesGrid'
      />
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <PageTitle>Invoices Grid</PageTitle>
      <Toolbar
        filters={filters}
        setFilters={setFilters}
        columns={columns}
        setColumns={setColumns}
        invoices={invoices}
        setInvoices={setInvoices}
        setLoading={setLoading}
        rowsPerPage={rowsPerPage}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        setTotalResults={setTotalResults}
        ascOrDesc={ascOrDesc}
        setAscOrDesc={setAscOrDesc}
        field={field}
        setField={setField}
      />
      <Table
        columns={columns}
        data={invoices}
        loading={loading}
        setPageNumber={setPageNumber}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        pageNumber={pageNumber}
        totalResults={totalResults}
        tableFor='Invoices'
      />
      <InvoiceBreakdownModal
        open={openInvoiceBreakdownModal}
        setOpen={setOpenInvoiceBreakdownModal}
        data={rowSelected}
      />
    </>
  )
}